import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { LessonPagination } from '@app/definitions/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';

@Component({
    selector: 'app-stat-pagination',
    templateUrl: './stat-pagination.component.html',
    styleUrls: ['./stat-pagination.component.scss']
})
export class StatPaginationComponent implements OnInit, OnDestroy {
    current_lesson: LessonPagination;
    first_lesson: LessonPagination = null;
    last_lesson: LessonPagination = null;
    previous_lessons: [LessonPagination];
    next_lessons: [LessonPagination];
    active_url: string;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private route: ActivatedRoute, private teacherService: TeacherService, private router: Router) {}

    public ngOnInit(): void {
        this.route.parent.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
            const lesson_id = params['lesson_id'];
            if (!!lesson_id) {
                this.teacherService
                    .getLessonsPagination(lesson_id)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(response => {
                        this.first_lesson = response.first_lesson;
                        this.last_lesson = response.last_lesson;
                        this.previous_lessons = response.previous_lessons.sort((a, b) => {
                            if (a.id > b.id) {
                                return 1;
                            } else {
                                return -1;
                            }
                        });
                        this.next_lessons = response.next_lessons;
                        this.current_lesson = response.current_lesson;
                    });
            }
        });
        this.route.url.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.active_url = params[0].path;
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public navigateTo(lesson_id: number): void {
        const navigationPath = `/teacher/analysis/${this.current_lesson.student_class}/${this.current_lesson.subject}/analytics/${lesson_id}`;
        switch (this.active_url) {
            case 'commontable':
                this.router.navigate([`${navigationPath}/commontable`]);
                break;
            case 'summary':
                this.router.navigate([`${navigationPath}/summary`]);
                break;
            case 'individual':
                this.router.navigate([`${navigationPath}/individual`]);
                break;
        }
    }

    public firstLessonClicked(): void {
        this.navigateTo(this.first_lesson.id);
    }

    public lastLessonClicked(): void {
        this.navigateTo(this.last_lesson.id);
    }

    public lessonClicked(lesson: LessonPagination): void {
        this.navigateTo(lesson.id);
    }

    public previousLessonClicked(): void {
        const previous_lesson = this.previous_lessons[this.previous_lessons.length - 1];
        this.navigateTo(previous_lesson.id);
    }

    public nextLessonClicked(): void {
        const next_lesson = this.next_lessons[0];
        this.navigateTo(next_lesson.id);
    }

    public getActivePageStyle(lessonPart: number): string {
        return lessonPart ? 'active-part--stat-pagination' : '';
    }
}
